import { connect } from "react-redux"
import { DonationHistoryWidget } from "QuorumGrassroots/widgets/DonationHistory/components"

import { donationHistoryWidgetConnection } from "QuorumGrassroots/widgets/DonationHistory/selectors"

export default connect(donationHistoryWidgetConnection, {})(DonationHistoryWidget)
